// extracted by mini-css-extract-plugin
export default {"wrapper":"SideNav_wrapper__EO9d2"};